import React from 'react';

import { PageGridItem } from 'corgi/common/components/PageGrid';

const VerticalSpacing = () => <PageGridItem pt={['sp_16', 'sp_20', 'sp_24', 'sp_32']} />;

export default VerticalSpacing;
